import { useState, useEffect } from 'react';

export type TWindowSize = {height?: number, width?: number};

export function useWindowSize(): TWindowSize {
  const [windowSize, setWindowSize] = useState<TWindowSize>({
    height: undefined,
    width: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
